import React, { useState, useEffect } from 'react';
import AdminLogin from '../components/admin/AdminLogin';
import AdminDashboard from '../components/admin/AdminDashboard';

const AdminPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated
    const token = localStorage.getItem('admin_token');
    const loginTime = localStorage.getItem('admin_login_time');
    
    if (token && loginTime) {
      const now = new Date().getTime();
      const loginTimestamp = parseInt(loginTime);
      // Token expires after 8 hours (8 * 60 * 60 * 1000 ms)
      const tokenExpiry = 8 * 60 * 60 * 1000;
      
      if (now - loginTimestamp < tokenExpiry) {
        setIsAuthenticated(true);
      } else {
        // Token expired, clear storage
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_login_time');
      }
    }
    
    setIsLoading(false);
  }, []);

  const handleLogin = (success) => {
    if (success) {
      // Store authentication token and timestamp
      const timestamp = new Date().getTime().toString();
      localStorage.setItem('admin_token', 'authenticated_' + timestamp);
      localStorage.setItem('admin_login_time', timestamp);
      setIsAuthenticated(true);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_login_time');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {isAuthenticated ? (
        <AdminDashboard onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
    </div>
  );
};

export default AdminPage;